import { t } from '@lingui/core/macro';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { NotificationsForm } from './-components/notifications-form';
import {
  SettingsSection,
  SettingsSectionSkeleton,
} from './-components/settings-section';
import { accountSettingsQueryOptions } from './-utils/account-settings-query';
import { SETTINGS_HELP } from './-utils/help-articles';

export const Route = createFileRoute(
  '/researchers/_authenticated/settings/notifications',
)({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(
      accountSettingsQueryOptions(context.user.id),
    ),
  pendingComponent: SettingsSectionSkeleton,
  component: NotificationsPage,
  head: () => ({ meta: [{ title: t`Notifications` }] }),
});

function NotificationsPage() {
  const { user } = Route.useRouteContext();
  const { data: settings } = useSuspenseQuery(
    accountSettingsQueryOptions(user.id),
  );

  return (
    <SettingsSection
      helpUrl={SETTINGS_HELP.general}
      title={t`Email notifications`}
      description={t`Choose which emails we send you about your projects.`}
    >
      <NotificationsForm
        settings={settings.notificationSettings}
        userId={user.id}
      />
    </SettingsSection>
  );
}
